import React from 'react';

const SequencePathBar = ({ steps, currentStep = 0, nextText = '', className = '' }) => {
  const safeCurrentStep = Math.max(0, Math.min(currentStep, steps.length - 1));

  return (
    <section className={`sequence-path-bar ${className}`.trim()} aria-label="Journey progress">
      <ol className="sequence-path-steps">
        {steps.map((step, index) => {
          const status = index < safeCurrentStep ? 'done' : index === safeCurrentStep ? 'current' : 'upcoming';

          return (
            <li
              key={step}
              className={`sequence-path-step sequence-path-step--${status}`}
              aria-current={index === safeCurrentStep ? 'step' : undefined}
            >
              <span className="sequence-path-marker">{index + 1}</span>
              <span className="sequence-path-label">{step}</span>
            </li>
          );
        })}
      </ol>

      <div className="sequence-path-meta">
        <strong>
          Step {safeCurrentStep + 1} of {steps.length}: {steps[safeCurrentStep]}
        </strong>
        {nextText ? <span>{nextText}</span> : null}
      </div>
    </section>
  );
};

export default SequencePathBar;